import type { Country } from '../country.model';

/** Canonical mock {@link Country} (United Arab Emirates). */
export const MOCK_COUNTRY: Country = {
  id: 1,
  name: 'United Arab Emirates',
  slug: 'united-arab-emirates',
  code: 'AE',
  dial_code: '+971',
  flag: '🇦🇪',
  currency: 'AED',
};

/** Builds a {@link Country} from {@link MOCK_COUNTRY} with overrides. */
export function createMockCountry(overrides?: Partial<Country>): Country {
  return { ...MOCK_COUNTRY, ...overrides };
}

/**
 * Pre-built list of GCC countries (UAE, KSA, Oman, Qatar, Kuwait,
 * Bahrain) commonly returned by `/api/v1/countries`.
 */
export const MOCK_COUNTRIES: Country[] = [
  MOCK_COUNTRY,
  createMockCountry({
    id: 2,
    name: 'Saudi Arabia',
    slug: 'saudi-arabia',
    code: 'SA',
    dial_code: '+966',
    flag: '🇸🇦',
    currency: 'SAR',
  }),
  createMockCountry({
    id: 3,
    name: 'Oman',
    slug: 'oman',
    code: 'OM',
    dial_code: '+968',
    flag: '🇴🇲',
    currency: 'OMR',
  }),
  createMockCountry({
    id: 4,
    name: 'Qatar',
    slug: 'qatar',
    code: 'QA',
    dial_code: '+974',
    flag: '🇶🇦',
    currency: 'QAR',
  }),
  createMockCountry({
    id: 5,
    name: 'Kuwait',
    slug: 'kuwait',
    code: 'KW',
    dial_code: '+965',
    flag: '🇰🇼',
    currency: 'KWD',
  }),
  createMockCountry({
    id: 6,
    name: 'Bahrain',
    slug: 'bahrain',
    code: 'BH',
    dial_code: '+973',
    flag: '🇧🇭',
    currency: 'BHD',
  }),
];

/**
 * Builds a list of mock {@link Country} entries. Returns the GCC list
 * by default; pass `count` to truncate or extend.
 */
export function createMockCountryList(
  count = MOCK_COUNTRIES.length,
  overrideAt?: (index: number) => Partial<Country>
): Country[] {
  return Array.from({ length: count }, (_, i) => {
    const base = MOCK_COUNTRIES[i % MOCK_COUNTRIES.length];
    return { ...base, id: i + 1, ...overrideAt?.(i) };
  });
}
